<!--START SELECTION BOXES-->
<h1>{{'RESULTS.SECTIONS.BASELINE_INPUT_SUMMARY' | anessaTranslation: trigger}}</h1>
<div class="row fl">
  <div class="fl-item">
    <!--MULTISELECT DROPDOWN-->
    <mat-form-field floatLabel="never"
                    class="anessa-dropdown">
      <mat-select
        multiple
        [(value)]="selectedInputs"
        (valueChange)="inputsChanged()"
        [placeholder]="'RESULTS.GENERAL.SELECT_RESULTS' | anessaTranslation: trigger"
        disableOptionCentering
        panelClass="anessa-dropdown-panel">
        <ng-container *ngIf="inputs !== null">
          <mat-checkbox
            class="mat-option mat-option-multi"
            color="primary"
            #outputsCheckbox
            (change)="checkAllInputs($event.checked)"
          >{{ outputsCheckbox.checked ? ('RESULTS.GENERAL.DESELECT_ALL' | anessaTranslation: trigger) :
              ('RESULTS.GENERAL.SELECT_ALL' | anessaTranslation: trigger)}}
          </mat-checkbox>
          <ng-container *ngFor="let section of inputSections">
            <mat-optgroup *ngIf="inputs[section].length > 0"
                          [label]="section" [disabled]="false">
              <mat-option
                *ngFor="let item of inputs[section]"
                [value]="item"><span [innerHTML]="item.name"></span></mat-option>
            </mat-optgroup>
          </ng-container>
        </ng-container>
      </mat-select>
    </mat-form-field>
  </div>
</div>
<!--END SELECTION BOXES-->

<!--Result display from here on-->
<div class="row fl" *ngIf="tableData && tableData.length > 0">
  <div class="fl-item">
    <app-result-table [tableData]="tableData"
                      [tableHeaders]="tableHeaders"
    ></app-result-table>
  </div>
</div>
